module.exports = function (done, value) {
  return { value: value, done: !!done };
};



// WEBPACK FOOTER //
// ./~/babel-polyfill/~/core-js/modules/_iter-step.js